const initialState = { setting: [] }

export default function SettingReducer(state = initialState, action) {
  switch (action.type) {
    case "SETTING_SUCCESS":
      return {
        success: true,
        setting: action.payload,
      }

    default:
      return state
  }
}
